import { isAppError } from '@/lib/result';

/**
 * Maps an unknown error to a translation key under `errors.*`. The UI never
 * shows raw errors (instructions/06_SECURITY.md — no information leakage).
 */
export function errorMessageKey(error: unknown): string {
  if (isAppError(error)) {
    switch (error.code) {
      case 'network':
        return 'errors.network';
      case 'not-authorized':
        return 'errors.notAuthorized';
      case 'conflict':
        return 'errors.conflict';
      case 'not-found':
        return 'errors.notFound';
      default:
        return 'errors.generic';
    }
  }
  return 'errors.generic';
}
